import React, { useState, useRef, useEffect } from "react";
import { CircularProgress, Grid } from "@mui/material";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import { CiCircleQuestion } from "react-icons/ci";
import ProjectLogo from "../../Assets/Images/Login/PSCAdminPortalLogin.svg";
import { GreenColorButton, PrimeGrayBorderColorButton } from "../../Components/MaterialButtonStyle/StyleButton";
import CustomModal from "../../Components/Modal/CustomModal";
import { PostMethod } from "../../Helper/api"
import {encryptData } from "../../Helper/Encryptions"

const VerifyOTP = () => {

  const length = 6;
  const navigate = useNavigate();
  const location = useLocation();
  const { isForgetPw, email, isApplicants } = location.state;
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [backScreen, setBackScreen] = useState(false);
  const inputRefs = useRef([]);
  const [otpNumber, setOtpNumber] = useState("");
  const [otptimer, setOTPTimer] = useState(60);
  const [ipaddress, setipaddress] = useState("");
  const [isLoading, setisLoading] = useState(false);
  useEffect(()=>{
    GetIpaddress()
  },[])

  const GetIpaddress =async()=>{
    try{
      const response =await fetch("https://api.ipify.org/")
      const data =await response.text()
      setipaddress(data)
    }catch(Error){
      console.log("Error GetIpaddress",Error)
    }
  }

  const handleChange = (value, index) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
    setOtpNumber(newOtp.join(""));
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").slice(0, length);
    const newOtp = otp.map((_, idx) => pasteData[idx] || "");
    setOtp(newOtp);
    const nextFocusIndex = pasteData.length < length ? pasteData.length : length - 1;
    inputRefs.current[nextFocusIndex]?.focus();
    setOtpNumber(newOtp.join(""));
  };

  const HandleRequestOTP = () => {
    setIsTimerActive(true);
    setOTPTimer(60);
  };

  const OtpValidation = async() => {
    try {
      if (otpNumber == "") {
        toast.warn("Please enter valid OTP number");
        return;
      }
      if (!otpNumber) {
        toast.warn("Please enter valid OTP number");
        return;
      }
      if (String(otpNumber)?.trim()?.length != 6) {
        toast.warn("OTP must be 6 digit number");
        return;
      }
      if (isForgetPw === false) {
        let url = "candidate/verifyloginotp";
        let method = "POST";
        let params = {
          email: email,
          otp: otpNumber,
          ipaddress:ipaddress,
          "fcmToken":""
        };
        setisLoading(true)
        const response = await PostMethod({ url, method, params });
        if(response.status){
          setisLoading(false)
          let data = response.result 
          let users = response.result.user 
          let userdata = { 
            first_name: users.candidate_first_name, 
            last_name: users.candidate_last_name, 
            email: users.candidate_email,
            role: data.roles,
            image:users.candidate_image
          }
          let user = JSON.stringify(userdata);
          let usersroles = "applicant"
          localStorage.setItem("@users", user);
          localStorage.setItem("islogedin", "true");
          localStorage.setItem("@userid", response.result.uuid);
          localStorage.setItem("@userType", usersroles);
          localStorage.setItem("@accesstoken", data.accessToken);
          navigate("/");
          window.location.reload();
        }else{
          setisLoading(false)
          if(response.message){
            toast.error(response.message)
          }else{
            toast.error("Something went wrong please try again")
          }
        }

      }
      if (isForgetPw === true) {
        ForgotPasswordOTP()
      }
    } catch (err) {
      setisLoading(false)
      toast.error("Something went wrong, try again later")
      console.log("err in OtpValidation", err);
    }
  };
  const ForgotPasswordOTP =async () =>{
    try{
      let url = "candidate/forgotverifyotp";
      let method = "POST";
      let params = {
        email: encryptData(email),
        otp: otpNumber,
        ipaddress:ipaddress,
        "fcmToken":""
      };
      setisLoading(true)
      const response = await PostMethod({ url, method, params });
      if(response.status){
        setisLoading(false)
        navigate("/resetpassword", { state: { isApplicants,email: email ,otp:otpNumber,token:response.token } });
        return;
      }else{
        setisLoading(false)
        if(response.message){
          toast.error(response.message)
        }else{
          toast.error("Something went wrong please try again")
        }
      }
    }catch(Error){
      setisLoading(false)
      console.log("Error",Error)
      toast.error("Something went wrong please try again")
    }
  }
  const ResendOtp = () => {
    try {
      HandleRequestOTP();
      toast.success("Resend OTP send successfully");
    } catch (err) {
      console.log("err in ResendOtp", err);
    }
  };

  const HandleVerifyOtpBack = () => {
    setOTPTimer(60);
    isApplicants ? navigate("/candidatelogin") : navigate("/");
  }

  useEffect(() => {
    if (otptimer < 0) {
      setIsTimerActive(false);
    } else {
      setIsTimerActive(true);
    }
    const intervalId = setInterval(() => {
      setOTPTimer((prevSeconds) => prevSeconds - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [otptimer]);

  return (
    <Grid
      container
      className="loginbgbanner"
      height={window.innerWidth > 800 ? "100vh" : "unset"}
      justifyContent={"space-between"}
      alignItems={"center"}
      padding={window.innerWidth > 800 ? 6 : 2}
      style={{ backgroundColor: "#02020280" }}
    >
      <Grid item container lg={5.8} md={5.8} sm={12} xs={12}>
        <h1 className="poppinsBold Text-Prime-Green  text-left">
          Welcome to <span className="Text-Prime-White">Police Service Commission</span> Recruitment Portal
        </h1>
      </Grid>
      <Grid
        item
        container
        lg={4}
        md={4}
        sm={12}
        xs={12}
        marginTop={window.innerWidth > 800 ? 0 : 4}
        flexDirection={"column"}
        justifyContent="center"
        className="bg-white borderRadius12 p-4"
      >
        <img
          src={ProjectLogo}
          alt="Instadoc-Project-Logo"
          className="projectlogo"
        />
        <h4 className="poppinsMedium Text-Prime-Black  text-center pt-3">
          Verify Your Email
        </h4>
        <p className=" poppinsRegular Text-Prime-Black pt-3">
          Enter the One Time Password Received to your registered email address
        </p>
        <Grid item lg={12} md={12} sm={12} xs={12} container flexDirection={"column"}>
          <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                value={digit}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onPaste={handlePaste}
                ref={(el) => (inputRefs.current[index] = el)}
                maxLength={1}
                style={{
                  width: window.innerWidth > 600 ? "50px" : "40px",
                  height: window.innerWidth > 600 ? "50px" : "40px",
                  textAlign: "center",
                  fontSize: "24px",
                  border: "1px solid #666666",
                  borderRadius: "5px",
                  backgroundColor: "#ffffff",
                  marginTop: "4%",
                  fontFamily: "PoppinsSemiBold"
                }}
              />
            ))}
          </div>
          {isTimerActive ? <p className=" poppinsRegular Text-Prime-Green pt-3">Resend OTP in: {otptimer}s</p> : <p role="presentation" className=" poppinsRegular Text-Prime-Green pt-3 pointer" onClick={() => ResendOtp()}>Resend OTP</p>}
          <Grid container justifyContent={"space-between"} sx={{ marginTop: "10%" }}>
            <PrimeGrayBorderColorButton className="px-5 py-2" sx={{ width: "48%" }} onClick={() => setBackScreen(true)}>Back</PrimeGrayBorderColorButton>
            <GreenColorButton
              type="submit"
              className="px-5 py-2"
              sx={{ width: "48%" }}
              disabled={isLoading}
              onClick={() => OtpValidation()}
            >
              {isLoading ?   <CircularProgress size="1rem" style={{ color: "#fff" }} /> :"Verify"}
            </GreenColorButton>
          </Grid>
        </Grid>
      </Grid>
      <CustomModal
        open={backScreen}
        setOpen={setBackScreen}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={<Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CiCircleQuestion color={"#12A59B"} size={100} />
          <p className=" poppinsRegular Text-Prime-Black pt-3 text-center">Do you want to naviate to login screen?</p>
          <Grid item container display={"flex"} justifyContent={"center"} sx={{ marginTop: "6%" }}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-3 py-2"
              onClick={() => setBackScreen(false)}
            >
              No
            </PrimeGrayBorderColorButton>
            <GreenColorButton
              type="submit"
              className="px-3 py-2 ml-2"
              onClick={() => HandleVerifyOtpBack()}
            >
              Yes
            </GreenColorButton>
          </Grid>
        </Grid>
        }
      />
    </Grid>
  );
};

export default VerifyOTP;